import { formatEstimatedDeliveryDate } from "@/helpers/pdpHelpers/dateHelpers";
import styles from "./EstimatedDelivery.module.scss";

//common component to display estimated delivery date
const EstimatedDelivery = ({ deliveryDate,text, estimatedDeliveryDate }) => {
  if(estimatedDeliveryDate){
    return (
      <span className={`x-small-md x-small-sm ${styles.deliveryDate} italic`}>
        {estimatedDeliveryDate}
      </span>
    );
  }
  else if(deliveryDate) {
    return (
      <span className={`x-small-md x-small-sm ${styles.deliveryDate} italic`}>
        {formatEstimatedDeliveryDate(deliveryDate)?.dateString}
      </span>
    );
  }
  return (
    <div className={`x-small-md x-small-sm ${styles.deliveryText} italic`}>
      {text}
    </div>
  );
};

export default EstimatedDelivery;
